module.exports = __webpack_public_path__ + "img/paint-roller.86f2ecd1.svg";